var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20845)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FD8654"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20845)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#FD8654"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20845)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20845)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9402 17.9501C27.2735 15.3168 27.3069 13.2835 27.0402 11.8501C26.8069 10.4168 26.1235 9.70015 24.9902 9.70015C23.8569 9.70015 22.9735 10.4168 22.3402 11.8501C21.7402 13.2835 21.2569 15.3168 20.8902 17.9501C20.5569 20.5835 20.4902 22.6168 20.6902 24.0501C20.8902 25.4501 21.5569 26.1501 22.6902 26.1501C23.8569 26.1501 24.7569 25.4668 25.3902 24.1001C26.0235 22.7001 26.5402 20.6501 26.9402 17.9501ZM31.6402 17.9501C31.3402 20.0168 30.9069 21.8001 30.3402 23.3001C29.8069 24.8001 29.1402 26.0168 28.3402 26.9501C26.7735 28.7835 24.7402 29.7001 22.2402 29.7001C19.7402 29.7001 17.9402 28.7835 16.8402 26.9501C15.7735 25.1168 15.5402 22.1168 16.1402 17.9501C16.7735 13.7501 17.8569 10.7335 19.3902 8.90015C20.9569 7.06681 23.0069 6.15015 25.5402 6.15015C28.0735 6.15015 29.8569 7.08348 30.8902 8.95015C31.9569 10.9501 32.2069 13.9501 31.6402 17.9501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3996 6.55014L11.2496 29.2501H6.49961L8.99961 11.3501C8.26628 11.8835 7.53294 12.4168 6.79961 12.9501C6.09961 13.4835 5.43294 13.9668 4.79961 14.4001L3.09961 11.4501C3.76628 10.9501 4.44961 10.4668 5.14961 10.0001C5.88294 9.50014 6.54961 9.03347 7.14961 8.60014C7.78294 8.16681 8.36628 7.78347 8.89961 7.45014C9.43294 7.08347 9.84961 6.78347 10.1496 6.55014H14.3996Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20845",
    x: 3.09961,
    y: 6.15015,
    width: 28.8359,
    height: 24.4867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20845",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20845",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20845",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound10);
export default __webpack_public_path__ + "static/media/motor_round_10.f67ce2dc590cadb2a1f8583851ad15ee.svg";
export { ForwardRef as ReactComponent };